/**
 * Returns true when running inside a Capacitor native app (iOS / Android).
 * Safe to call on web — dynamic import fails gracefully and returns false.
 */
export async function isNativeApp(): Promise<boolean> {
  try {
    const { Capacitor } = await import('@capacitor/core')
    return Capacitor.isNativePlatform()
  } catch {
    return false
  }
}
